<template>
  <div class="market-chart">
    <div class="chart-top-area">
      <Select
        v-model="dimension"
        class="chart-dimension"
      >
        <Option
          v-for="item in dimensionOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </Select>
      <RadioGroup
        v-model="chartType"
        class="chart-type-group"
        @change="getChartData"
      >
        <RadioButton
          plain
          label="饼柱图"
        />
        <RadioButton
          plian
          label="折线图"
        />
      </RadioGroup>
    </div>
    <div
      v-loading="chartLoading"
      class="chart-main-area"
    >
      <LineChart
        v-if="chartType === '折线图'"
        :chartData="lineData"
        :dimension="dimensionItem"
      />
      <BarChart
        v-else-if="isBar"
        :chartData="pieData"
        :dimension="dimensionItem"
      />
      <PieChart
        v-else
        :chartData="pieData"
        :dimension="dimensionItem"
      />
    </div>
  </div>
</template>

<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui';
import moment from 'moment';
import Request from '@/core/QuRequest';
import PieChart from './PieChart';
import LineChart from './LineChart';
import BarChart from './BarChart';

const req = new Request();

export default {
  name: 'MarketChart',
  components: {
    Select,
    Option,
    RadioGroup,
    RadioButton,
    PieChart,
    LineChart,
    BarChart,
  },
  props: {
    type: {
      type: String,
      required: true,
      default: 'media',
    },
    timePeriod: {
      type: Array,
      required: true,
      default() {
        return ['', ''];
      },
    },
  },
  data() {
    return {
      dimension: 'cost',
      dimensionOptions: [
        // 线上问题王晓阳
        // {
        //   label: '请求数',
        //   value: 'request_num'
        // },
        // {
        //   label: '有效请求数',
        //   value: 'served_request_num'
        // },
        // {
        //   label: '填充率',
        //   value: 'filled_rate'
        // },
        {
          label: '展示',
          value: 'show_num',
        },
        {
          label: '点击',
          value: 'click_num',
        },
        {
          label: '消耗',
          value: 'cost',
        },
        {
          label: 'CTR',
          value: 'ctr',
        },
        {
          label: 'ECPM',
          value: 'ecpm',
        },
        {
          label: 'ACP',
          value: 'acp',
        },
        {
          label: '有消耗账户数',
          value: 'served_account_num',
        },
      ],
      barDimensions: ['filled_rate', 'ctr', 'ecpm', 'acp'],
      chartType: '饼柱图',
      chartOptions: {
        tooltip: {
          trigger: 'item',
          formatter: '{b} <br/>{a}: {c} ({d}%)',
        },
        legend: {
          orient: 'horizontal',
          left: 'left',
          top: 24,
          data: [],
        },
        series: [],
      },
      pieData: null,
      lineData: null,
      chartLoading: false,
    };
  },
  computed: {
    dimensionItem() {
      return this.dimensionOptions.find(
        (item) => item.value === this.dimension,
      );
    },
    isBar() {
      return this.barDimensions.includes(this.dimension);
    },
  },
  watch: {
    timePeriod: {
      immediate: false,
      handler(info) {
        this.getChartData();
      },
    },
  },
  created() {
    this.getChartData();
  },
  methods: {
    async getChartData() {
      try {
        this.chartLoading = true;
        let params = {
          start_date: moment(this.timePeriod[0]).format('YYYY-MM-DD'),
          end_date: moment(this.timePeriod[1]).format('YYYY-MM-DD'),
          dimension: this.type,
        };
        if (this.chartType === '饼柱图') {
          this.pieData = await req.send(req.Apis.sales.report.pieData, params);
        } else {
          this.lineData = await req.send(
            req.Apis.sales.report.lineData,
            params,
          );
        }
        this.chartLoading = false;
      } catch (err) {
        this.chartLoading = false;
        this.$message.error(`获取chart数据失败：${err.message || '未知错误'}`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.market-chart {
  .chart-top-area {
    .chart-type-group {
      float: right;
    }
  }
}
</style>
